import { SampleDetails } from "@/interfaces/samples";


function state(): SampleDetails {
    return {
        sampleId: 0,
        nombre: '',
        clientId: 0,
        projectId: 0,
        fecha_creacion: '',
        id_conf_files_grupo: 0,
        ejecucion: 0,
        sampleTotal: 0,
        sampleReview: 0,
        editSample: false,
        deleteUnreviewed: false,
        showAddDocTypesModal: false,
        reloadSamplesList: false,

    }

}

export default state;